import { HoverCard } from '@mantine/core';
import { ScheduleEventData } from '@mantine/schedule';
import type { PayloadType } from '../../types';
import { EventButton, EventHoverCard } from './components';

type ScheduleEventPropsType = {
  event: ScheduleEventData<PayloadType>;
} & React.ComponentPropsWithoutRef<'button'> & {
    children: React.ReactNode;
  };

export const ScheduleEvent: React.FC<ScheduleEventPropsType> = ({
  event,
  ...props
}) => {
  return (
    <HoverCard offset={0}>
      <HoverCard.Target>
        <EventButton event={event} {...props} />
      </HoverCard.Target>
      <HoverCard.Dropdown>
        <EventHoverCard event={event} />
      </HoverCard.Dropdown>
    </HoverCard>
  );
};
